"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.structureSalesposterResponse = void 0;
/**
 * Parses salesposter response into structured data
 * @param unstructured the response from salesposter endpoint in json format
 * @returns html, css + metadata
 */
var structureSalesposterResponse = function (unstructured) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var html = (_b = (_a = unstructured === null || unstructured === void 0 ? void 0 : unstructured.data) === null || _a === void 0 ? void 0 : _a.content) !== null && _b !== void 0 ? _b : '';
    var campaign = (_d = (_c = unstructured === null || unstructured === void 0 ? void 0 : unstructured.data) === null || _c === void 0 ? void 0 : _c.campaign) !== null && _d !== void 0 ? _d : '';
    var contentName = (_f = (_e = unstructured === null || unstructured === void 0 ? void 0 : unstructured.data) === null || _e === void 0 ? void 0 : _e.contentName) !== null && _f !== void 0 ? _f : '';
    var segmentName = (_h = (_g = unstructured === null || unstructured === void 0 ? void 0 : unstructured.data) === null || _g === void 0 ? void 0 : _g.segmentName) !== null && _h !== void 0 ? _h : '';
    var posterType = (_k = (_j = unstructured === null || unstructured === void 0 ? void 0 : unstructured.data) === null || _j === void 0 ? void 0 : _j.posterType) !== null && _k !== void 0 ? _k : '';
    var abTestGroup = (_m = (_l = unstructured === null || unstructured === void 0 ? void 0 : unstructured.data) === null || _l === void 0 ? void 0 : _l.abTestGroup) !== null && _m !== void 0 ? _m : '';
    return {
        html: html,
        campaign: campaign,
        contentName: contentName,
        segmentName: segmentName,
        posterType: posterType,
        abTestGroup: abTestGroup,
    };
};
exports.structureSalesposterResponse = structureSalesposterResponse;
//# sourceMappingURL=structure-response.js.map